<template>
  <span class="insights-order-number">{{ order }}</span>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    order: number;
  }>(),
  {
    order: 0
  }
);
</script>

<style scoped lang="scss">
.insights-order-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #0054ff;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}
</style>
